import React from "react";
import Button from "../button/Button";

const Pagination = ( props ) => {

  const table = props.table ?? ''
  const pageSize = !! props.pageSize || Array.isArray( props.pageSize ) ? props.pageSize : [10, 20, 30, 40, 50]

  return (
    <>
    { table &&
      <div className="msync-pagination">
        <div className="msync-pagination__meta">
          <span>Showing {((table.getState().pagination.pageIndex) * table.getState().pagination.pageSize) + 1} - </span>
            <label><span className='msync-visually-hidden'>Records per page</span>
            <select
              value={table.getState().pagination.pageSize}
              onChange={ e => { table.setPageSize(Number(e.target.value)) }}
            >
            { pageSize.map( pageSize => (
              <option key={ pageSize } value={ pageSize }>{((table.getState().pagination.pageIndex) * pageSize) + pageSize}</option>
            )) }
          </select>
          </label>
          <span>of </span> 
          <strong>{ table.getPrePaginationRowModel().rows.length }</strong>
        </div>
        <div className="msync-pagination__controls">
          <div className="msync-pagination__controls__buttons">
            <Button 
              className="msync-pagination__controls__buttons__item first"
              onClick={() => table.setPageIndex(0)}
              isDisabled={!table.getCanPreviousPage()}
            >
              &lsaquo;&lsaquo; <span className="msync-visually-hidden">First Page</span>
            </Button>
            <Button 
              className="msync-pagination__controls__buttons__item previous"
              onClick={() => table.previousPage()}
              isDisabled={!table.getCanPreviousPage()}
            >
              &lsaquo; <span className="msync-visually-hidden">Previous Page</span>
            </Button>
            <Button 
              className="msync-pagination__controls__buttons__item next"
              name=">"
              onClick={() => table.nextPage()}
              isDisabled={!table.getCanNextPage()}
            >
              <span className="msync-visually-hidden">Next Page</span> &rsaquo;
            </Button>
            <Button 
              className="msync-pagination__controls__buttons__item last"
              onClick={() => table.setPageIndex(table.getPageCount() - 1)}
              isDisabled={!table.getCanNextPage()}
            >
              <span className="msync-visually-hidden">Last Page</span> &rsaquo;&rsaquo;
            </Button>
          </div>
          <div className="msync-pagination__controls__inputs">
            <span>Page </span>
            <strong>
              {table.getState().pagination.pageIndex + 1} of{' '}
              {table.getPageCount()}
            </strong>
            <span> | Go to page: </span>
            <input
              type="number"
              disabled={!table.getCanNextPage() && !table.getCanPreviousPage()}
              defaultValue={table.getState().pagination.pageIndex + 1}
              onChange={e => {
                const page = e.target.value ? Number(e.target.value) - 1 : 0
                table.setPageIndex(page)
              }}
            />
          </div>
        </div>
      </div>
    }
    </>
  )

}

export default Pagination
